module.exports = __webpack_public_path__ + "img/login.11020fea.png";